module.exports = __webpack_public_path__ + "24_vis4ai.jpg?410c5813d857cde1e0793d6679880a4f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_vis4ai.jpg
// module id = 215
// module chunks = 0